import "./App.css";
import { Box } from "@mui/material";

import VideoSection from "./components/videoSection";
import Header from "./components/header";
import About from "./components/about";
import ContactForm from "./components/form";
import Footer from "./components/footer";

function App() {
  return (
    <Box className="App" sx={{ background: "#010207" }}>
      <Header />
      <VideoSection />
      <Box sx={{p: {xs:'0 16px'}}}>
        <About />
        <ContactForm />
        <Footer />
      </Box>
    </Box>
  );
}

export default App;
